import React from 'react';

/**
 * Wrapper component for draggable blocks in the email builder.
 */
class BuilderBlock extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        switch (nextProps.dataType) {
            case 'column':
            case 'layout':
            case 'layout-horizontal':
            case 'layout-vertical':
                return true;
        }
        return !nextProps.dragging;
    }

    handleClick(event) {
        if (event) {
            event.stopPropagation();
        }
        if (this.props.onBlockClick) {
            this.props.onBlockClick(this.props.blockId);
        }
    }

    render() {
        const props = this.props;
        let className = 'builder-block draggable';
        if (props.active) {
            className += ' draggable-active';
        }
        let dragOutline;
        switch (props.dataType) {
            case 'column':
            case 'layout':
            case 'layout-horizontal':
            case 'layout-vertical':
                className += ' layout';
                break;
            default:
                if (props.renderDragOutline != false) {
                    dragOutline = <span className="drag-outline" />;
                }
                break;
        }
        if (props.className) {
            className += ` ${props.className}`;
        }
        return (
            <div
                align="center"
                border={0}
                className={className}
                cellPadding={props.cellPadding || "0"}
                cellSpacing={props.cellSpacing || "0"}
                data-block-type={props.blockType}
                data-type={props.dataType}
                draggable={props.builder == true}
                height="100%"
                id={props.blockId}
                width="100%"
                onClick={this.handleClick}
                onDragEnter={props.onDragEnter}
                onDragStart={props.onDragStart}>
                {props.children}
                {dragOutline}
            </div>
        );
    }
}

export default BuilderBlock;

